import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";

import swal from "sweetalert";

const CursosSelector = (props) => {
  const [curso, setCurso] = useState("");
  const [cursosOptions, setCursosOptions] = useState([]);
  const [cursoSearch, setCursoSearch] = useState("");

  const handleCursoChange = useCallback((e, { options, value }) => {
    const text = options?.find((option) => option.value === value)?.text || "";
    setCurso(value);
    setCursoSearch(text);

    if (props.handleChange) {
      props.handleChange({value, text});
    }
  }, []);

  const handleCursoSearchChange = useCallback((e) => {
    try {
      const search = e.target.value;

      setCursoSearch(search);

      api.get(`cursos-simplelist?search=${search}&limit=15`).then((res) => {
        if (res.data.length > 0) {
          const options = res.data.map((course, index) => ({
            key: index,
            text: `[${course.id}] ${course.curso}`,
            value: course.id,
          }));
          setCursosOptions(options);
          return;
        }
        setCursosOptions([]);
      });
    } catch (err) {

      setCursosOptions([]);
    }
  });

  return (
    <Container>
      <div>
        {!props?.noLabel && (<Label>Selecione o curso</Label>)}
        <Dropdown
          placeholder="Busque pelo ID ou pelo nome do curso"
          fluid
          search
          selection
          options={cursosOptions}
          onChange={handleCursoChange}
          searchQuery={cursoSearch}
          onSearchChange={handleCursoSearchChange}
          value={curso}
          clearable
        />
      </div>
    </Container>
  );
};

export default CursosSelector;
